export default "__VITE_ASSET__Ckgmh$Nw__"